/**
 * Join the text of one speaker's consecutive live segments for display.
 *
 * The server buffer already glues sub-word pieces. This is the second line of
 * defence for a run the 3-second flush split: no space before punctuation, and
 * no space when the previous piece ends in a hyphen ("sound-" + "proof").
 */

const LEADING_PUNCTUATION = /^[,.;:!?)…'’]/

export function needsSpaceBetween(previous: string, next: string): boolean {
  const left = previous.trimEnd()
  const right = next.trim()
  if (left.length === 0 || right.length === 0) return false
  if (LEADING_PUNCTUATION.test(right)) return false
  if (left.endsWith("-")) return false
  return true
}

export function joinSpeakerRun(texts: readonly string[]): string {
  let out = ""
  for (const raw of texts) {
    const text = raw.trim()
    if (text.length === 0) continue
    if (out.length === 0) {
      out = text
      continue
    }
    out = needsSpaceBetween(out, text) ? `${out} ${text}` : `${out}${text}`
  }
  return out
}

/**
 * Changes whenever any visible transcript text changes, including a final that
 * lands inside an existing speaker run with the same character count as the
 * interim it replaces. A length sum misses that and the view stops following.
 */
export function transcriptContentSignature(
  segments: readonly { speaker: string; text: string }[],
  interimText: string,
  interimSpeaker: string,
): string {
  let sig = `${segments.length}\u0001${interimSpeaker}\u0001${interimText}`
  for (const seg of segments) {
    sig += `\u0001${seg.speaker}\u0001${seg.text}`
  }
  return sig
}
